module.exports = __webpack_public_path__ + "media/tip_tier_3-22f41326bae5418af1a91e2ff87b69d8.mp3";